import styled from 'styled-components';

const ToolbarWithNoPortal = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background-color: white;
  height: 60px;
  border-bottom: 1px solid var(--grey200);
`;

export default ToolbarWithNoPortal;
